import { Component, OnInit } from '@angular/core';
import { UserManagementService } from '../../service/user-management.service';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
@Component({
  selector: 'app-list-user',
  templateUrl: './list-user.component.html',
  styleUrls: ['./list-user.component.css']
})
export class ListUserComponent implements OnInit {

  search: string = "";
  resultTable: any[] = null;
  cols: any[];
  //errFlag:boolean=false;
  //errMsg:string="";
  constructor(private dataService: UserManagementService, private router: Router) {}

  ngOnInit() {
    this.cols = [
      // { field: 'Id', header: '' },
      { field: 'FullName', header: 'שם' },
      { field: 'UserName', header: 'שם משתמש' },
      { field: 'RoleName', header: 'הרשאה' },
      { field: 'OtpDate', header: 'תאריך כניסה אחרון' }
    ];
  }

  getSearchUser(searchUser: NgForm): void {
    if (searchUser.valid) {
      this.search = this.search === "" ? "" : this.search;
      this.dataService.getSearchUsers(this.search).subscribe((result: any) => {
        this.resultTable = result;
      },
        (err: HttpErrorResponse) => {
          //console.log(err);
         // this.errFlag = true;
          //this.errMsg = err.error.ExceptionMessage;
          this.router.navigate(['error-page/', err.error.ExceptionMessage])
        });
    }
  }

  onClick(id: string) {
    this.router.navigate(['update-user/', id])
  }

}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/user-management/list-user/list-user.component.ts